import { useRef } from 'react';
import ReactDOM from 'react-dom';
import GenerateButton from '../Components/Common/GenerateButton';

const useRenderGenerateBtn = () => {
  const parentRef = useRef(null);
  const generateInReactQuill = (btnProps = {}, tool = '.ql-toolbar') => {
    if (!parentRef?.current) return;
    const toolbar = parentRef?.current?.querySelector(tool);
    if (toolbar) {
      let div = toolbar.querySelector('.generate-button-container');
      if (!div) {
        div = document.createElement('span');
        div.className = 'generate-button-container ql-formats mr-0';
        toolbar.appendChild(div); 
      }
      ReactDOM.unmountComponentAtNode(div);
      ReactDOM.render(<GenerateButton {...btnProps} />, div);
    }
  }

  return {
    parentRef,
    generateInReactQuill
  }
}

export default useRenderGenerateBtn;
